<template>
  <li>
    <span class="tree-item audio-form-item" :data-node-id="node.intId">
      <div
        v-if="parent"
        ref="draggable"
        class="drag-item panzoom-ignore"
        draggable
        @dragstart="dragStart"
        @dragend="dragEnd">
        <v-icon class="mt-n1" color="error"> mdi-cursor-move</v-icon>
      </div>
      <div v-if="parent" @click="removeNode" class="remove-node">
        <v-icon>mdi-close</v-icon>
      </div>

      <div>
        <AudioFormStep v-if="node.data.itemType === 'step'" :node.sync="node" :tree="tree"></AudioFormStep>
        <AudioFormButton v-if="node.data.itemType === 'button'" :node.sync="node" :tree="tree"></AudioFormButton>
      </div>

      <div
        ref="dropzone"
        class="drop-zone"
        :class="{ invisible: !allowButtonDrop && !allowStepDrop }"
        @dragover="dragOver"
        @dragenter="dragEnter"
        @dragleave="dragLeave"
        @drop="drop"></div>
    </span>
    <ul v-if="node.children && node.children.length">
      <AudioFormTreeNode
        v-for="child in node.children"
        :key="child.intKey"
        :node="child"
        :parent.sync="node"
        :tree="tree"
        :drag-data="dragData"
        @item-drag-start="emitItemDragStart"
        @item-drop="emitItemDrop"
        @item-drag-end="emitItemDragEnd"></AudioFormTreeNode>
    </ul>
  </li>
</template>

<script>
  import AudioFormButton from "./AudioFormButton.vue";
  import AudioFormStep from "./AudioFormStep.vue";

  /* eslint-disable */
  export default {
    components: {
      AudioFormStep,
      AudioFormButton,
    },
    name: "AudioFormTreeNode",
    props: {
      node: {
        type: Object,
        required: true,
      },
      tree: {
        type: Object,
        required: true,
      },
      parent: {
        type: Object || null,
      },
      dragData: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      allowButtonDrop() {
        if (this.dragData?.currentlyDraggedNode?.data?.itemType !== "button") return false;
        if (this.node.data.itemType !== "step") return false;

        return true;
      },
      allowStepDrop() {
        if (this.dragData?.currentlyDraggedNode?.data?.itemType !== "step") return false;
        if (this.node.data.itemType !== "button") return false;
        if (this.node.children.length >= 1) return false;

        return true;
      },
    },
    methods: {
      removeNode() {
        this.tree.removeNode(this.parent, this.node);
      },
      dragEnter() {
        this.$refs.dropzone?.classList.add("drop-zone--active");
      },
      dragLeave() {
        this.$refs.dropzone?.classList.remove("drop-zone--active");
      },
      dragOver(e) {
        e.preventDefault();
      },
      drop(e) {
        e.preventDefault();
        this.$refs.dropzone?.classList.remove("drop-zone--active");
        this.emitItemDrop(this.node);
      },
      dragStart(e) {
        e.dataTransfer.dropEffect = "move";
        e.dataTransfer.effectAllowed = "move";
        this.$refs.draggable?.classList.add("drag-item--dragging");
        this.emitItemDragStart(this.node);
      },
      dragEnd(e) {
        this.$refs.draggable?.classList.remove("drag-item--dragging");
        this.emitItemDragEnd();
      },
      /**
       * Emits are required since the component is recursive, so in order to emit to the actual parent (which is AudioFormTree),
       * we have to emit "recursively" as well.
       */
      emitItemDragStart(node) {
        this.$emit("item-drag-start", node);
      },
      emitItemDragEnd() {
        this.$emit("item-drag-end");
      },
      emitItemDrop(node) {
        this.$emit("item-drop", node);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";

  .audio-form-item {
    border-radius: 5px !important;
    background: get-color("element-bg-100");
    max-width: 700px;
    padding: 20px 10px 5px 10px;
  }

  .remove-node {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;
  }

  .drag-item {
    position: absolute;
    top: 10px;
    left: 10px;
    &--dragging {
      opacity: 0.2;
    }
  }

  .drop-zone {
    height: 30px;
    width: 30px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 50%);
    border-radius: 50%;
    border: 1px dashed get-color("primary");
    background-color: get-color("primary-20");
    z-index: 9999;
    &--active {
      border: 2px solid get-color("primary");
    }
  }

  // We have to use visibility because changing DOM triggers dragAbort
  .invisible {
    visibility: hidden;
  }
</style>
